import { useProposalExtractionToast } from "../hooks/useProposalExtractionToast";

// Mounts the proposal-extraction toast only once `ecoRfpId` is known, so the
// underlying `useProposalDocumentsQuery` poll never fires with an empty RFP id
// on the initial (pre-load) render. Same gating rationale as AiCellStateSyncer.
export const ProposalExtractionToaster = ({
  ecoRfpId,
  rfpId,
}: {
  ecoRfpId: string;
  rfpId: string | undefined;
}): null => {
  useProposalExtractionToast(ecoRfpId, rfpId);
  return null;
};
